"use client";
import * as SliderRadix from "@radix-ui/react-slider";
import { Label } from "./Label";

interface SliderProps extends SliderRadix.SliderProps {}

export function Slider({
  max = 100,
  step = 1,
  defaultValue = [27, 125],
  onValueChange,
  value,
  min,
}: SliderProps) {
  const [labelLeft, labelRight] = value || [];

  return (
    <div className="flex gap-x-4 items-center">
      <Label className="min-w-[20px]">{labelLeft}</Label>
      <SliderRadix.Root
        className="relative flex h-5 w-[200px] touch-none select-none items-center"
        defaultValue={defaultValue}
        min={min}
        max={max}
        step={step}
        onValueChange={onValueChange}
      >
        <SliderRadix.Track className="relative h-[3px] grow rounded-full bg-gray-300">
          <SliderRadix.Range className="absolute h-full rounded-full bg-black" />
        </SliderRadix.Track>
        <SliderRadix.Thumb
          className="block size-5 rounded-[10px] bg-white shadow-[0_2px_4px] shadow-blackA4 hover:bg-violet3 focus:shadow-[0_0_0_5px] focus:shadow-blackA5 focus:outline-none"
          aria-label="Volume"
        />
        <SliderRadix.Thumb
          className="block size-5 rounded-[10px] bg-white shadow-[0_2px_4px] shadow-blackA4 hover:bg-violet3 focus:shadow-[0_0_0_5px] focus:shadow-blackA5 focus:outline-none"
          aria-label="Volume"
        />
      </SliderRadix.Root>
      <Label className="min-w-[20px]">{labelRight}</Label>
    </div>
  );
}
